/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PageProductSortimentEntryResponse } from '../../models/page-product-sortiment-entry-response';

export interface GetProductSortimentEntries$Params {

/**
 * UUID of the product sortiment entry (productSortimentId)
 */
  prodSortId: string;

/**
 * Zero-based page index (0..N)
 */
  page?: number;

/**
 * The size of the page to be returned
 */
  size?: number;

/**
 * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 */
  sort?: Array<string>;
}

export function getProductSortimentEntries(http: HttpClient, rootUrl: string, params: GetProductSortimentEntries$Params, context?: HttpContext): Observable<StrictHttpResponse<PageProductSortimentEntryResponse>> {
  const rb = new RequestBuilder(rootUrl, getProductSortimentEntries.PATH, 'get');
  if (params) {
    rb.path('prodSortId', params.prodSortId, {});
    rb.query('page', params.page, {});
    rb.query('size', params.size, {});
    rb.query('sort', params.sort, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PageProductSortimentEntryResponse>;
    })
  );
}

getProductSortimentEntries.PATH = '/sortiments/products/{prodSortId}/entries';
